import clsx from 'clsx'
import { MailboxUI } from 'features/messaging'
import { memo } from 'react'
import { Link, useLocation } from 'react-router-dom'
import typo from 'shared/styles/typography.module.scss'

import css from './NavigationMenu.module.scss'
import { useAppSelector } from '../../../shared/hooks'
import { appSelectors } from '@appStore/reducers/app.ts'
import { CONSTS } from '../../../config/objectConst'

interface LinkItem {
	href: string
	isCurrent: (pathname: string) => boolean
	label: string
}

const createLink = (
	href: string,
	label: string,
	isCurrent = (pathname: string) => pathname.startsWith(href)
): LinkItem => ({
	href,
	isCurrent,
	label
})

const links: LinkItem[] = [
	createLink(
		'/campaigns',
		'Campaigns',
		pathname =>
			pathname.startsWith('/campaigns') || pathname.startsWith('/archive')
	),
	createLink('/contacts', 'Contacts'),
	createLink('/messaging', 'Messaging'),
	createLink('/team/members', 'Team', pathname => pathname.startsWith('/team'))
]

function useNavigationLinks() {
	const isIgnoredMessagingPersona = useIsIgnoredMessagingPersona()

	return isIgnoredMessagingPersona
		? links.filter(({ href }) => href !== '/messaging')
		: links
}

export const useIsIgnoredMessagingPersona = () => {
	const personaId = useAppSelector(state => appSelectors.persona(state)?.personaId)
	const ignorePersonas = (CONSTS.MESSAGING.IGNORE_PERSONAS ?? []) as string[]

	return Boolean(personaId && ignorePersonas.includes(personaId))
}

function NavigationMenu_() {
	const { pathname } = useLocation()
	const linksList = useNavigationLinks()

	return (
		<nav>
			<ul className={css.list}>
				{linksList.map(({ href, isCurrent, label }) => {
					const isActive = isCurrent(pathname)

					return (
						<li key={href}>
							<Link
								aria-current={isActive ? 'page' : undefined}
								className={clsx(
									typo[isActive ? 'buttonSmB' : 'buttonSm'],
									css.link,
									isActive && css.active
								)}
								to={href}
							>
								{label}

								{href === '/messaging' && <MailboxUI.UnreadCount />}
							</Link>
						</li>
					)
				})}
			</ul>
		</nav>
	)
}

export const NavigationMenu = memo(NavigationMenu_)
